/**
 * CargaCorreiosCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaCorreios} from '@/model/resource/CargaCorreios'

/* TODO: review generated class */
@HttpExclude()
export class CargaCorreiosCollection extends PageCollection<CargaCorreios> {
  constructor() {
    super(CargaCorreios)
  }

  queryAsPage() {
    return this.listCargaCorreios()
  }

  async listCargaCorreios() {
    return await Request.get(`/admin/carga-correios`, {params: this.params})
      .name('listCargaCorreios')
      .as(this)
      .getResponse()
  }

  async listCsvCargaCorreios() {
    return await Request.get(`/admin/carga-correios/csv`, {params: this.params})
      .name('listCsvCargaCorreios')
      .as(this)
      .getResponse()
  }
}
